import * as _ from "lodash";
import { history } from "../";
import * as Const from "../Constants";
import * as StateHelper from "../Helpers/appState";
import * as Models from "../Models";
import { downloadDocumentsEntityDocument } from "../Api/azure";
import filterItemsStore from "../Store/filterItems";

export const scrollTop: Function = () => {
  // Scroll to top when clicking links
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};

export const documentLinkToLink: Function = (
  document: Models.DocumentLink
): Models.Link => {
  return {
    id: document.fileName,
    type: Const.LINK_TO_SAS,
    description: document.fileName,
    url: document.url,
  };
};

export const linkToDocumentLink: Function = (
  link: Models.Link,
  hostId: string
): Models.DocumentLink => {
  return {
    type: link.type,
    fileName: link.description,
    url: link.url,
    metaData: { hostId: hostId } as Models.DocumentMeta,
    reasonForDelete: "",
    pending: false,
  };
};

export const attributeCellToLink: Function = (
  cell: Models.AttributeCell
): Models.Link => {
  return {
    id: cell.description,
    type: Const.LINK_TO_INTERNAL_PAGE, // Attributes can be linked only to portal itself
    description: cell.description,
    url: cell.url.url,
  };
};

export const fileToDocumentLinkUpload: Function = (
  siteDetail: Models.SiteDetail,
  file: File
): Models.DocumentLinkUpload => {
  var index: number = file.name.lastIndexOf(".");
  var nameAndType: string[] = [
    file.name.slice(0, index),
    file.name.slice(index + 1),
  ];

  return {
    fileName: nameAndType[0],
    filetype: nameAndType[1],
    type: Const.LINK_TO_LOCAL,
    url: (file as any).preview, // url to localhost address to file
    file: file,
    target: `/api/sites/${siteDetail.id}/documents/upload`,
    metaData: {
      hostId: siteDetail.id,
      created: "", // Data will be filled on backend
      createdBy: "",
      documentType: "",
      siteName: siteDetail.siteName,
      functionalLocation: siteDetail.description,
      documentId: "",
      workOrder: "",
    },
    reasonForDelete: "",
    pending: false,
  };
};

export const breadcrumbToLink: Function = (
  breadcrumb: Models.BreadcrumbItem
): Models.Link => {
  return {
    id: breadcrumb.description,
    type: Const.LINK_TO_INTERNAL_PAGE, // breadcrumbs can be linked only to portal itself
    description: breadcrumb.description,
    url: breadcrumb.Url,
  };
};

export const selectLink: any = async (
  e: any,
  link: Models.Link
): Promise<any> => {
  e.preventDefault();
  if (!link.url) {
    return;
  } else if (link.type === Const.LINK_TO_EXTERNAL_PAGE) {
    window.open(link.url);
  } else if (link.type === Const.LINK_TO_SAS) {
    if (link.additionalInfo) {
      downloadDocumentsEntityDocument(link, link.additionalInfo);
    } else {
      window.open(encodeURI(link.url), "_blank");
    }
  } else if (link.openToNewTab === true) {
    window.open(linkToRelativeUrl(link), "_blank");
  } else if (link.additionalInfo?.toLowerCase() == "project") {
    const projectUrl: Models.UrlParams = {
      filter: link.type,
      itemType: "Project",
      parameter: link.id,
    };
    pushTo(projectUrl);
  } else {
    const urlParams: Models.UrlParams = {
      filter: link.type,
      itemType: link.type,
      parameter: link.id,
    };
    pushTo(urlParams);
  }
};

export const pushTo: Function = async (
  params: Models.UrlParams,
  replace?: boolean
): Promise<any> => {
  const { filter, itemType, parameter, queryParams } = params;

  let url: string = `/`;

  if (filter) {
    url += `${filter}`;
  } else {
    url += `sites`;
  }

  if (itemType) {
    url += `/${itemType.toLocaleLowerCase()}`;
  }

  if (parameter) {
    url += `/${parameter}`;

    const activeDetail: Models.ActiveDetail = filterItemsStore
      .getState()
      .getActiveDetail(params);
    const item: Models.DetailView = activeDetail?.detail;

    if (item !== undefined) {
      if (StateHelper.isNavigationItemHidden(item)) {
        url += `/${item.parent}`;
      }
    }
  }

  if (queryParams !== undefined && Object.keys(queryParams).length > 0) {
    url += "?";
    _.forEach(Object.keys(queryParams), (o) => {
      url += `${o}=${queryParams[o]}`;
    });
  }
  if (replace) {
    history.replace(url);
  } else {
    history.push(url);
  }
  // if (!state.changeRequest.isDirty) {
  //     store.dispatch(closeChangeRequestViews());
  // }
  scrollTop();
};

export const linkToRelativeUrl: (linkUrl: Models.Link) => string = (
  linkUrl
) => {
  if (!linkUrl.url) {
    return "";
  }

  let url: string = "/";

  if (linkUrl.additionalInfo?.toLowerCase() == "project") {
    url += `sites/project/${linkUrl.id}`;
  } else if (linkUrl.type === Const.CUSTOMERS_TREE) {
    url += `customers/customers/${linkUrl.id}`;
  } else if (linkUrl.type === Const.SITE_TREE) {
    url += `sites/location/${linkUrl.id}`;
  } else if (linkUrl.type === Const.PRODUCTS_TREE) {
    url += `products/product/${linkUrl.id}`;
  } else if (linkUrl.type === Const.LINK_TO_EXTERNAL_PAGE) {
    return linkUrl.url;
  }

  return url;
};
